var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.officeMode)?_c('span',[_vm._v(_vm._s(_vm.code))]):_c('img',{attrs:{"src":_vm.source,"alt":_vm.code}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b97ee51","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thread/Message/Icon.vue
// module id = 673
// module chunks = 1